import { render, staticRenderFns } from "./user_cbtlook.vue?vue&type=template&id=0dde3877"
import script from "./user_cbtlook.vue?vue&type=script&lang=js"
export * from "./user_cbtlook.vue?vue&type=script&lang=js"
import style0 from "./user_cbtlook.vue?vue&type=style&index=0&id=0dde3877&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports